import { ActionFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { mutateData } from '~/api/data/request';
import { submitMutation } from '~/api/data/responses';
import {
  DisconnectMailboxDocument,
  DisconnectMailboxMutation,
  DisconnectMailboxMutationVariables
} from '~/api/graphql';

export const disconnectMailbox = (variables: DisconnectMailboxMutationVariables) =>
  mutateData<DisconnectMailboxMutation, DisconnectMailboxMutationVariables>(client, {
    mutation: DisconnectMailboxDocument,
    variables
  });

export const submitDisconnectMailbox: ActionFunction = async ({ request }) => {
  const { id } = await request.json();
  return submitMutation(disconnectMailbox({ id }));
};
